import * as React from 'react';
import { Table, TableCell, TableContainer, TableRow, TableHead, TableBody } from '@mui/material';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import moment from 'moment';
import PageInfo from 'components/PageInfo';
import { getFileManagersByQuery } from 'components/axios/fileManagerAxios';
import { fileAccepts } from 'data/data';
import { useEnumApi } from 'contexts/EnumApiContext';
import { useTranslation } from 'react-i18next';
import { fromServerFormat } from 'components/date_picker/dateUtils';

const EquipmentData = ({info, currentPage, setCurrentPage, onSelectItem}) => {
    const { t } = useTranslation();
    const { getEnumValueByEnumNameAndCode } = useEnumApi();

    let [pageInfo, setPageInfo] = useState({});
    // const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);

    const [datas, setDatas] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      setIsLoading(false);
    }
  
    useEffect(()=> {
      if (!isLoading && !isNaN(currentPage)) {
        dataList();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, isLoading]);

    if (!info) return;
    const dataList = async(curPage=currentPage) => {
      if (isNaN(curPage)) {setCurrentPage(0)};
      if(isNaN(pageSize)) {setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);}
  
      let param = {
        page : curPage,
        size : pageSize,
        fileManagerType : "C"
      };

      param["equipmentCtgr.parent.id"] = info.equipmentCtgr.parent.parent.id;
      param["equipmentCtgr.id"] = info.equipmentCtgr.parent.id;

      await getFileManagersByQuery(param).then((data)=>{
        // console.log(data)
        if (data != null) {
          setPageInfo(data.page);
          if(data._embedded) {
            setDatas(data._embedded.fileManagers);
          } else {
            setCurrentPage(0);
            setDatas([]);
          }
        } else {
          pageInfo = {
            size : pageInfo.size,
            totalElements : 0,
            totalPages : 0,
            number : 0
          }
          setPageInfo(pageInfo);
          setDatas([]);
        }
      });
      setIsLoading(true);
    }

    return (
    <div style={{padding:"15px 0"}}>
    <Box
        id="tableDiv"
        sx={{
            mt: 3,
            padding: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            background: "#182131",
            border: "1px solid rgba(255,255,255,0.06)",
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
        }}
    >
      <TableContainer>
        <Table className="list_table" sx={{ minWidth: 600 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}}>
          <TableHead>
            <TableRow>
              <TableCell className="th" align="center">No.</TableCell>
              <TableCell className="th" align="center">{t('message.common.select.division')}</TableCell>
              <TableCell className="th" align="center">{t('message.common.subtitle.type2')}</TableCell>
              <TableCell className="th" align="center">{t('message.common.subtitle.title')}</TableCell>
              <TableCell className="th" align="center">{t('message.common.subtitle.createdate')}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
          { datas && datas.map(function(item, i) {
            let accept = null;
            if (item.attachedFiles && item.attachedFiles.length > 0) {
                const extension = item.attachedFiles[0].originFile.substring(item.attachedFiles[0].originFile.lastIndexOf("."));
                accept = fileAccepts.filter(acc => acc.extension.indexOf(extension.toLowerCase()) !== -1);
            }
            return(
            <TableRow key={i} onClick={() => onSelectItem(item.id)} style={{ cursor: 'pointer'}}>
              <TableCell align="center">{pageInfo.totalElements-((currentPage)*pageInfo.size)-i}</TableCell>
              <TableCell align="center">{item.fileType && getEnumValueByEnumNameAndCode("FileType", item.fileType) && getEnumValueByEnumNameAndCode("FileType", item.fileType)?.[0]?.title}</TableCell>
              <TableCell align="center">{accept && (t(accept[0].titleKey) || '')}</TableCell>
              <TableCell align="center">{item.title}</TableCell>
              <TableCell align="center">{fromServerFormat(item.createdAt, {format:t('message.common.text.date.format.date')})}</TableCell>
            </TableRow>
            )
          }) }
          </TableBody>
        </Table>
      </TableContainer>

      <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
    </Box>
  </div>
  );
}

export default EquipmentData;